import { Menu } from "@mantine/core";
import { ReactElement, useContext } from "react";
import { BellRinging, Edit, Trash } from "tabler-icons-react";
import { UserContext } from "../../providers/user";

type Props = {
  onEdit: () => void;
  onDelete: () => void;
  onReporting: () => void;
  controlButton: ReactElement;
};

export default function LocationOptionsMenu(props: Props) {
  const { onEdit, onDelete, onReporting, controlButton } = props;
  const { isAuthorized } = useContext(UserContext);

  return (
    <Menu control={controlButton}>
      <Menu.Label>Options</Menu.Label>

      {isAuthorized(["notification_setting"]) && (
        <Menu.Item
          sx={(theme) => ({
            color:
              theme.colorScheme === "dark"
                ? theme.colors.dark[0]
                : theme.colors["custom-gray"][0],
          })}
          icon={<BellRinging size={20} />}
          onClick={onReporting}
        >
          Edit notifications
        </Menu.Item>
      )}

      {isAuthorized(["location_update"]) && (
        <Menu.Item
          sx={(theme) => ({
            color:
              theme.colorScheme === "dark"
                ? theme.colors.dark[0]
                : theme.colors["custom-gray"][0],
          })}
          icon={<Edit size={20} />}
          onClick={onEdit}
        >
          Edit
        </Menu.Item>
      )}

      {isAuthorized(["location_destroy"]) && (
        <Menu.Item
          color="custom-red"
          icon={<Trash size={20} />}
          onClick={onDelete}
          sx={(theme) => ({
            "&:hover": {
              backgroundColor: theme.colors["custom-red"][1],
            },
          })}
        >
          Delete
        </Menu.Item>
      )}
    </Menu>
  );
}
